export enum AuthFlowsEnum {
  LOGIN = 'login',
  BENEFICIARY = 'beneficiary',
  // Tech story:9278 Exchanges are currently not supported for confirmation preferences, hence commenting out the exchange flow. It can be added back when the support is added.
  // EXCHANGE = 'exchange',
  CARDS = 'cards',
  BULK_PAYMENT = 'bulkPayment',
  PAYMENT_REQUEST = 'paymentRequest',
}
